/* eslint-disable max-len */
import React from 'react';
function SignOut() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M10.1,15.6l1.4,1.4l5-5l-5-5l-1.4,1.4l2.6,2.6H3v2h9.7L10.1,15.6z M19,3H5C3.9,3,3,3.9,3,5v4h2V5h14v14H5v-4H3v4 c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z" })));
}
export default SignOut;
